import * as React from "react";
export class Label extends React.Component {
    render() {
        return (React.createElement("span", { className: "rj-racing-future-events__arena" }, this.props.label));
    }
}
//# sourceMappingURL=Label.js.map